<template>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
    <div class="datatables">
      <div class="block block-mode-hidden">
        <div v-if="tableLoader && showLoader" class="overlay"></div>
        <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#F5F5F5" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-danger">
          <h3 class="block-title text-white">
            <i class="fa fa-box-open"></i> Packages ({{ Object.keys(packages).length }})
            <span class="hash-loader" v-if="showLoader && !tableLoader">
              <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
            </span>
          </h3>
          <div class="block-options">
            <button type="button" class="btn-block-option text-white" data-toggle="modal" data-target="#create_package">
            <i class="si si-plus"></i> Add New
            </button>
            <button type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
          </div>
        </div>
        <div class="block-content block-content-full">
          <table id="packages-table" class="table table-bordered table-striped table-vcenter js-dataTable-full table-sm">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Label</th>
                <th class="d-none d-sm-table-cell">Type</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>{{ getPackageEntries }}
              <tr v-for="(pack,  index) in packages" :key="index">
                <td class="text-center font-size-sm">{{ pack.Id }}</td>
                <td class="text-center font-w600 font-size-sm">{{ pack.Label }}</td>
                <td class="text-center font-w600 font-size-sm">{{ pack.PackageType }}</td>
                <td class="text-center font-w600 font-size-sm">{{ pack.Quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <AddPackage
      @showSuccessMsg="displaySuccessMsg"
      @loadPackage="getAndParsePackages"
    ></AddPackage>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import AddPackage from '@/components/modals/AddPackage';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';
Vue.use(VueSpinners);

export default {
  name: 'Package',
  data() {
    return {
      packages: [],
      isTableEnabled: false,
      showLoader: false,
      tableLoader: false
    };
  },
  components: {
    HashLoader,
    AddPackage
  },
  mounted() {
    $('.package-select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: jQuery(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });

    this.getAndParsePackages(false);
  },
  computed: {
    getPackageEntries() {
      if (this.$store.state.library.packages.length) {
        return this.enableDataTable(this.$store.state.library.packages);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllPackages']),
    ...mapGetters('library', ['getPackages']),
    async getAndParsePackages(force) {
      let vm = this;
      if (force || vm.getPackages().length === 0) {
        vm.showLoader = true;
        await vm.getAllPackages();
      }
      if (vm.getPackages().length === 0) {
        vm.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#packages-table').DataTable();
        table.destroy();
      }
      vm.packages = data;
      vm.prepareDataTable('#packages-table');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    beforeDestroy() {
      this.clear();
    },
    displaySuccessMsg(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    showAddPackageModal() {
      jQuery('#create_package').modal('show');
    }
  }
};
</script>

<style>
.custom-control {
  min-height: 1rem !important;
  margin: 0 !important;
}
.clone-title {
  display: inline-block;
  margin: 0;
  line-height: 0;
}
.clone-content .remove-facility.border-facility {
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// source/components/boxes/Package.vue